/**
 * Created by hp on 2017/8/16.
 */
import React, {Component} from 'react';
import {connect} from 'react-redux';
import axios from 'axios';
import {WKError} from '../../components';
import {WKPreload} from '../../components/wk';
import {RelaySettingCell, RelaySettingMoney} from '../../components/relaySetting';
import errorImg from '../../images/no-source.png'
import { isLZWKAPP } from '../../utils'


class RelaySettingLecture extends Component {
    componentDidMount() {
        const {id} = this.props.relaySetting;

        axios.get(`/api/relay/lecture/${id}/edit_info`).then(res => {
            if (res.data.code === 0) {
                this.props.dispatch({type: 'RELAY_SETTING_DATA_INIT', payload: res.data.data});
            }
        }).catch(error => {
            let payload = {
                tips: '你不是管理员。',
                img: errorImg,
                href: '/',
                btn: '回到首页'
            };

            if (error.response && error.response.status === 404) {
                payload = {
                    tips: '访问的页面不存在。',
                    img: errorImg,
                    href: '/',
                    btn: '回到首页'
                }
            }
            this.props.dispatch({
                type: 'ERROR_SHOW',
                payload
            })
        })
    }


    render() {
        const {initialized, id} = this.props.relaySetting;
        const {error} = this.props;

        if (error.showError) {
            return (
                <div className="relay-setting-lecture">
                    <WKError />
                </div>
            )
        }

        if (!initialized) {
            return <WKPreload />
        }

        return (
            <div className="relay-setting-container relay-setting-lecture">
                {
                    !isLZWKAPP() && (
                        <RelaySettingCell title="邀请用户转载课程" description="您可邀请公众号运营方、群主或好友等转载课程，让您的微课被更多人关注"
                            href={`/relay_setting/share/${id}`}/>
                    )
                }

                <RelaySettingCell title="管理转载者" description="可查看谁转载了课程，或解除转载者的转载权限"
                                  href={`/relay_setting/list/lecture/${id}`}/>

                <RelaySettingMoney title="开启转载" description="" relayType="lecture"/>
            </div>
        )
    }
}

export default connect((state) => ({
    relaySetting: state.relaySetting,
    error: state.error,
}))(RelaySettingLecture);



// WEBPACK FOOTER //
// ./src/components/relaySetting/RelaySettingLecture.js